import { DOT, STYLES, REFERENCES } from "../constants";
import type { ISpeechToTextButtonSettings } from "../models";
import type { IKendoJQuery } from "../../core";

declare const kendo: any;

export interface ISpeechHandlerCallbacks {
    onStart: (e: any) => void;
    onEnd: (e: any) => void;
    onResult: (e: any) => void;
    onError: (e: any) => void;
}

export interface ISpeechHandlerContext {
    wrapper: IKendoJQuery;
    getSpeechToTextButtonOption: () => boolean | ISpeechToTextButtonSettings | null;
    callbacks: ISpeechHandlerCallbacks;
}

export class SpeechHandler {
    private context: ISpeechHandlerContext;
    private instance: any = null;

    constructor(context: ISpeechHandlerContext) {
        this.context = context;
    }

    init(): void {
        const option = this.context.getSpeechToTextButtonOption();

        if (option === false) {
            return;
        }

        const speechToTextButton = this.context.wrapper.find(`[${REFERENCES.speechToTextButton}], ${DOT}${STYLES.speechToTextButton}`).first();
        if (!speechToTextButton.length) {
            return;
        }

        const defaultSettings: ISpeechToTextButtonSettings = {
            fillMode: "flat",
            size: "small",
            rounded: "full",
            enable: true
        };

        const userSettings = typeof option === "object" && option !== null ? option : {};
        const isEnabled = (userSettings as ISpeechToTextButtonSettings).enable !== false;

        const buttonOptions = {
            ...defaultSettings,
            ...userSettings,
            messages: {
                start: "Start listening",
                stop: "Stop listening",
                ...(userSettings as any).messages
            },
            start: (e: any) => this.context.callbacks.onStart(e),
            end: (e: any) => this.context.callbacks.onEnd(e),
            result: (e: any) => this.context.callbacks.onResult(e),
            error: (e: any) => this.context.callbacks.onError(e)
        };

        this.instance = new kendo.ui.SpeechToTextButton(speechToTextButton, buttonOptions);

        if (!isEnabled) {
            this.instance.enable(false);
        }
    }

    enable(enabled: boolean): void {
        if (this.instance) {
            this.instance.enable(enabled);
        }
    }

    destroy(): void {
        if (this.instance) {
            this.instance.destroy();
            this.instance = null;
        }
    }
}
